var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import moment from "moment";
import { TabValues } from "../../../../Account/useUpdateOrderDeliveryModal/deliveryModalUtils/const-enums-types";
import { checkCurrentOrderPlaceChange, } from "../../../../Account/useUpdateOrderDeliveryModal/deliveryModalUtils/checkCurrentOrderPlaceChange";
import { AddressesText, } from "../../../../Addresses/Addresses-types";
import { ERROR_MESSAGE_GENERIC } from "../../../utils/constants";
import { ModalContent } from "../../Modal";
import { doesPlaceChangeRequireReschedule } from "../../../../Account/utils/requestsTS";
import { PaymentProcessor } from "../../../../Account/BillingInformation/Shared/types/PaymentProcessorTypes";
export const baseCardStyles = (themeColor) => ({ color: "black", border: `1px solid ${themeColor}` });
export const primaryCardStyles = (themeColor) => ({
    border: `2px solid ${themeColor}`,
});
// ***** TYPE CHECK
// Determines the address type being passed to the component.
// A pickup location does not currently have an isPrimary var, so if that is not defined
// we know that it's a pickup address.
export const isDeliveryAddress = (address) => {
    return (address === null || address === void 0 ? void 0 : address.isPrimary) !== undefined;
};
// ***** TYPE CHECK
// A delivery location does not have a name var, but a pickup location does.
export const getIsPickupLocation = (address) => {
    return (address === null || address === void 0 ? void 0 : address.name) !== undefined;
};
export const getChipText = (isPrimaryAddress, isDeliveryAddressCard, city) => {
    if (isPrimaryAddress && isDeliveryAddressCard)
        return AddressesText.PRIMARY;
    if (!isDeliveryAddressCard && !!city)
        return city;
};
export const onAddUpdateOrderDeliveryPickupLocationSuccess = (toast, closeModal, setTabValue, setBalance, setLoading, setIsFormSubmitted, showModal, confirmThenUpdate, paymentProcessor, setShouldDisplayPaymentForm, resetContext, paymentAmount, paymentMethod, initPayWithPaymentMethod, refetchOrders) => (data) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    setLoading(true);
    setIsFormSubmitted(false);
    if (!data.success) {
        if (data.restartPayFlow && paymentMethod && paymentAmount && initPayWithPaymentMethod) {
            initPayWithPaymentMethod({
                PaymentMethodId: paymentMethod,
                Amount: paymentAmount,
            });
            setLoading(false);
            toast.push((_a = data.message) !== null && _a !== void 0 ? _a : ERROR_MESSAGE_GENERIC, {
                variant: "error",
            });
        }
        else if (data.extraStep) {
            const paymentProcessorString = PaymentProcessor[paymentProcessor].toLowerCase();
            const paymentProcessorResponse = data[paymentProcessorString];
            showModal({
                title: "Payment Confirmation",
                content: (_jsx(ModalContent, { children: _jsx("iframe", { style: { height: "75vh", overflow: "scroll", border: "none", width: "100%" }, src: paymentProcessorResponse.redirectToUri }) })),
                closeModalFunc: () => {
                    confirmThenUpdate();
                },
                maxWidth: "md",
                fullWidth: true,
            });
        }
        else {
            setLoading(false);
            toast.push((_b = data.message) !== null && _b !== void 0 ? _b : ERROR_MESSAGE_GENERIC, {
                variant: "error",
            });
        }
    }
    else {
        if (((_c = data.balance) === null || _c === void 0 ? void 0 : _c.remainingBalance) > 0) {
            setBalance(data.balance);
            setTabValue(TabValues.NONE); // ! This is not a valid option for the Tabs component. It needs to be handled differently.
            setShouldDisplayPaymentForm && setShouldDisplayPaymentForm(true);
            setLoading(false);
        }
        else {
            if (refetchOrders)
                refetchOrders();
            setIsFormSubmitted(true);
            setLoading(false);
            toast.push(AddressesText.ADDRESS_UPDATED, { variant: "success" });
            if (resetContext)
                resetContext();
            closeModal();
        }
    }
});
export const onAddUpdateOrderDeliveryPickupLocationError = (toast, setLoading, setIsFormSubmitted) => () => {
    setIsFormSubmitted(false);
    setLoading(false);
    toast.push(ERROR_MESSAGE_GENERIC, { variant: "error" });
};
/**
 * * This function determines if the current address card is the current selection.
 * @param currentAddressData
 * @param initTabProps
 * @returns
 */
const isCurrentSelection = (currentAddressData, initTabProps) => {
    if (!!(currentAddressData === null || currentAddressData === void 0 ? void 0 : currentAddressData.address_id))
        return String(initTabProps === null || initTabProps === void 0 ? void 0 : initTabProps.initDeliveryLocation) === String(currentAddressData === null || currentAddressData === void 0 ? void 0 : currentAddressData.address_id);
    if (!(currentAddressData === null || currentAddressData === void 0 ? void 0 : currentAddressData.address_id))
        return String(initTabProps === null || initTabProps === void 0 ? void 0 : initTabProps.initPickupLocation) === String(currentAddressData === null || currentAddressData === void 0 ? void 0 : currentAddressData.location_sku);
};
export const shouldUseBorderAsSelected = (isUpdateOrderModal, isPrimaryAddress, isDeliveryAddressCard, newAddressData, currentAddressCardData, initTabProps) => {
    // If it is not the order update modal, we are only determining if it's the primary address.
    if (!isUpdateOrderModal)
        return isPrimaryAddress;
    // Display the border on the current (saved) address/location, IF a new selection has not been made.
    // new address data will not have an address id or location sku
    if (!(newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.address_id) && !(newAddressData === null || newAddressData === void 0 ? void 0 : newAddressData.location_sku) && !!initTabProps)
        return isCurrentSelection(currentAddressCardData, initTabProps);
    if (isUpdateOrderModal && !!newAddressData) {
        // If this is a delivery order, find and style the current (saved) delivery card.
        if (isDeliveryAddressCard)
            return newAddressData.address_id === (currentAddressCardData === null || currentAddressCardData === void 0 ? void 0 : currentAddressCardData.address_id);
        // If this is a pickup order, find and style the current (saved) pickup/location card.
        return newAddressData.location_sku === (currentAddressCardData === null || currentAddressCardData === void 0 ? void 0 : currentAddressCardData.location_sku);
    }
    // If none of these conditions apply, return undefined (no styling).
    return undefined;
};
export const createRemappingModalAddressLine = (address) => {
    const { address1, address2, city, state, zip } = address;
    return `${address1 !== null && address1 !== void 0 ? address1 : ""}, ${!!address2 ? `${address2}, ` : ""}${city !== null && city !== void 0 ? city : ""}, ${state !== null && state !== void 0 ? state : ""} ${zip !== null && zip !== void 0 ? zip : ""}`;
};
export const getDeliveryDates = (days) => { var _a; return (_a = days === null || days === void 0 ? void 0 : days.map((day) => moment(day.delivery_date).format("L"))) !== null && _a !== void 0 ? _a : []; };
const noDeliveryDatesResponse = {
    success: false,
    isAbleToBeModified: false,
    isPlaceUpdated: false,
    isRescheduleRequired: true,
    message: "No delivery dates found",
    newDeliveryScheduleId: undefined,
};
/**
 * * This function is only used on the checkout page.
 * This function uses the updated DoesCurrentOrderPlaceChangeRequireReschedule endpoint.
 * This endpoint looks at the delivery schedule compatibility of the new address.
 * This check does not reject the change request based solely on the delivery schedule id.
 * The new/selected address data will be set if the order is compatible with the new address,
 * otherwise the remapping modal will be opened.
 * @param currentAddressCardData The address card that has been selected by the user.
 * @param orderInfo The order info for the current order, either an existing order or the order being created.
 * @param setNewAddressData The function that sets the new address data to state.
 * @param setShowOrderRemappingModal The function that opens the remapping modal, if necessary.
 * @param showDeliveryScheduleWarningModal The function that opens the delivery schedule warning modal, if necessary. Only for new orders.
 * @param flowSku The order flow sku, if this is a new order.
 * @param nextLocation The target location when attempting to change the order location at checkout.
 * @param orderId The order id. If this is a new order, the id will be -1.
 * @returns void
 */
export const handleChangeAddressClick_CheckoutPage = (currentAddressCardData, orderInfo, setNewAddressData, setShowOrderRemappingModal, showDeliveryScheduleWarningModal, address, flowSku, orderId) => () => __awaiter(void 0, void 0, void 0, function* () {
    var _d;
    const { zip: targetZipCode, LocationId: targetLocationId } = currentAddressCardData;
    const { days, program_id: currentOrderProgramId } = orderInfo !== null && orderInfo !== void 0 ? orderInfo : {};
    const nextLocation = (address === null || address === void 0 ? void 0 : address.locationSku) ? address : undefined;
    // If the target location is the same as the current order location, do not check for reschedule.
    if ((orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.location_id) && String(orderInfo.location_id) === String(currentAddressCardData === null || currentAddressCardData === void 0 ? void 0 : currentAddressCardData.LocationId)) {
        setNewAddressData(currentAddressCardData);
        return;
    }
    // If the target address is the same as the current order address, do not check for reschedule.
    if ((orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.address_id) && String(orderInfo.address_id) === String(currentAddressCardData === null || currentAddressCardData === void 0 ? void 0 : currentAddressCardData.address_id)) {
        setNewAddressData(currentAddressCardData);
        return;
    }
    let response = noDeliveryDatesResponse;
    if ((_d = days === null || days === void 0 ? void 0 : days.length) !== null && _d !== void 0 ? _d : 0 > 0) {
        const currentOrderDeliveryDates = getDeliveryDates(days);
        response = yield checkCurrentOrderPlaceChange(currentOrderDeliveryDates, currentOrderProgramId !== null && currentOrderProgramId !== void 0 ? currentOrderProgramId : -1, targetZipCode, targetLocationId !== null && targetLocationId !== void 0 ? targetLocationId : null);
    }
    if (response.isRescheduleRequired || !response.success) {
        orderId === -1
            ? showDeliveryScheduleWarningModal(currentAddressCardData, nextLocation, flowSku, undefined, response.newDeliveryScheduleId)
            : setShowOrderRemappingModal((prev) => !prev);
        return;
    }
    else {
        setNewAddressData(currentAddressCardData);
        return;
    }
});
// * This function is only used on the account pages.
// This function does not use the updated DoesCurrentOrderPlaceChangeRequireReschedule endpoint.
export const handleChangeAddressClick_AccountPages = (orderId, setNewAddressData, currentAddressCardData, setShowOrderRemappingModal) => () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield doesPlaceChangeRequireReschedule(orderId, currentAddressCardData === null || currentAddressCardData === void 0 ? void 0 : currentAddressCardData.location_sku, currentAddressCardData === null || currentAddressCardData === void 0 ? void 0 : currentAddressCardData.address_id);
    if (response.isRescheduleRequired) {
        setShowOrderRemappingModal((prev) => !prev);
    }
    else {
        setNewAddressData(currentAddressCardData);
    }
});
export const getAddressChangeClick = (isCheckout, currentAddressCardData, orderInfo, setNewAddressData, setShowOrderRemappingModal, showDeliveryScheduleWarningModal, address, flowSku, orderId) => {
    // If we are on the checkout page, then we use the updated method.
    if (isCheckout)
        return handleChangeAddressClick_CheckoutPage(currentAddressCardData, orderInfo, setNewAddressData, setShowOrderRemappingModal, showDeliveryScheduleWarningModal, address, flowSku, orderId);
    // If we are not on the checkout page, then we are on an account page and we use the old method.
    // We may eventually use the same method for both.
    else
        return handleChangeAddressClick_AccountPages(orderId, setNewAddressData, currentAddressCardData, setShowOrderRemappingModal);
};
